/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 2/16/16,
 * Refactored by kyang on 9/30/19.
 */

function PartnerSearchViewController(
    this: JS5Object,
    $scope: JS5Object,
    $location: JS5Object,
    uiGridConstants: JS5Object,
    NotificationService: JS5Object,
    BreadcrumbService: JS5Object,
    ModalService: JS5Object,
    NavbarUtilService: JS5Object,
    PartnerResourceFactory: JS5Object,
    PaginationService: JS5Object,
    SearchFilterService: JS5Object,
) {

    //======//
    // Grid //
    //======//

    const gridColumns = [
        {
            field: 'name',
            name: 'Name',
            sort: {
                direction: uiGridConstants.ASC,
                priority: 0
            },
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }, {
            field: 'subscriptionCount',
            name: 'Subscriptions',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];

    const gridRowSelectionChangedHandler = (row: JS5Object) => {
        if(row.isSelected) {
            this.selectedPartner = row.entity;
        } else {
            this.selectedPartner = null;
        }
    };

    this.currentGridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: gridColumns,
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged($scope, gridRowSelectionChangedHandler);
        }
    };

    const openPartnerEditView = (partner: JS5Object) => {
        BreadcrumbService.addBreadcrumb({
            location: '/system/partners/search',
            name: 'Partners',
            params: angular.copy($location.search())
        });
        $location.url('/system/partners/edit/' + partner.id + '/properties');
    };

    this.onRowDblClick = (row: JS5Object) => {
        openPartnerEditView(row.entity);
    };

    //=========//
    // Toolbar //
    //=========//

    const hideMessage = 'Are you sure you want to hide ';
    const unhideMessage = 'Are you sure you want to unhide ';
    const openConfirmModal = (messageText: string, title: string, handler: JS5Object) => {
        messageText += this.selectedPartner.name + '?';
        title += this.selectedPartner.name + '?';
        ModalService.showMessageModal({
            messageText: messageText,
            pullCancelLeft: true,
            title: title,
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, handler);
    };

    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: () => this.searchPerms.read && !!this.searchPerms.write,
            onClick: () => openPartnerEditView({id: -1})
        }, {
            label: 'Edit',
            enabled: () => this.searchPerms.read && this.searchPerms.write && !!this.selectedPartner,
            onClick: () => openPartnerEditView(this.selectedPartner)
        }, {
            label: 'Hide',
            enabled: () => this.searchPerms.read && this.searchPerms.write && this.selectedPartner && !this.selectedPartner.hidden,
            onClick: () => openConfirmModal(hideMessage, 'Hide', this.toggleArchiveFlag)
        }, {
            label: 'Unhide',
            enabled: () => this.searchPerms.read && this.searchPerms.write && this.selectedPartner && !!this.selectedPartner.hidden,
            onClick: () => openConfirmModal(unhideMessage, 'Unhide', this.toggleArchiveFlag)
        }
    ];

    this.toggleArchiveFlag = () => {
        this.loadingIndicator.show = true;
        PartnerResourceFactory.toggleArchive({id: this.selectedPartner.id}).$promise.then(() => {
            this.queryForGridData();
        });
    };

    this.toolbarCheckboxDefs = [{
        label: 'Show Hidden',
        onUpdate: (nowShowHidden: boolean) => {
            this.includeArchived = nowShowHidden;
            this.queryForGridData();
        }
    }];


    //============//
    // Pagination //
    //============//

    const onPaginationChanged = () => {
        this.queryForGridData();
    };

    const paginationPrevPageHandler = () => {
        --this.pagingOptions.currentPage;
        onPaginationChanged();
    };

    const paginationNextPageHandler = () => {
        ++this.pagingOptions.currentPage;
        onPaginationChanged();
    };

    const paginationPageSizeChangedHandler = () => {
        this.pagingOptions.currentPage = 1;
        onPaginationChanged();
    };

    this.paginationDefs = {
        paginationPrevPageHandler: paginationPrevPageHandler,
        paginationNextPageHandler: paginationNextPageHandler,
        paginationPageSizeChanged: paginationPageSizeChangedHandler,
        paginationJumpToPageHandler: onPaginationChanged,
        pagingOptions: PaginationService,
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.queryForGridData = () => {
        let offset = this.pagingOptions.pageSize * (this.pagingOptions.currentPage - 1);
        let queryOpts: JS5Object = {
            fetchOffset: offset,
            fetchLimit: this.pagingOptions.pageSize,
            includeHidden: this.includeArchived,
            type: this.contentType
        };
        if ($location.search().hasOwnProperty('searchText')) {
            queryOpts.searchString = $location.search().searchText;
        }
        this.loadingIndicator.show = true;
        this.selectedPartner = null;

        return PartnerResourceFactory.query(
            queryOpts,
            (data: JS5Object[], responseHeaders: JS5Function) => {
                PaginationService.parseResponseHeaders(responseHeaders());
            }
        ).$promise.then((data: JS5Object[]) => {
            PaginationService.pageData = data;
            this.currentGridOptions.data = data;
            this.loadingIndicator.show = false;
        });
    };

    this.$onInit = () => {
        this.pagingOptions = PaginationService;
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        this.searchPerms = {
            read: true,
            write: true,
            clone: {
                read: true,
                write: true,
                batch: {
                    write: true
                }
            }
        };

        NavbarUtilService.viewSearchFunction = this.queryForGridData;
        PaginationService.pageDataResource = PartnerResourceFactory;
        SearchFilterService.populateCriteriaFromLocationSearch();
        this.queryForGridData();
    };

    this.$onDestroy = () => {
        NavbarUtilService.viewSearchFunction = null;
    };
}

angular.module('prism-ui.partner').component(
    'partnerSearchview',
    {
        bindings: {},
        controller: PartnerSearchViewController,
        templateUrl: 'system/partner/searchView/partner-searchview-template.html'
    });
